/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { SourceAccountMetricsConfig } from '../models/SourceAccountMetricsConfig';

export class GetSourceAccountMetricsConfigResponse {
  'sourceAccountConfig': SourceAccountMetricsConfig;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "sourceAccountConfig",
      "baseName": "sourceAccountConfig",
      "type": "SourceAccountMetricsConfig",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GetSourceAccountMetricsConfigResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

